import { useMemo } from 'react';
import { useIntl } from 'react-intl';
/**
 * Returns localized aether labels for use with `AetherProvider`'s `labels` prop.
 *
 * Must be called inside a react-intl `IntlProvider`. For apps without i18n,
 * omit the `labels` prop on `AetherProvider` to use the built-in English defaults.
 */
export function useLocalizedAetherLabels() {
    const { $t } = useIntl();
    return useMemo(() => ({
        close: $t({
            defaultMessage: 'Close',
            id: 'a0a28fd8a7',
            description: 'Label for close buttons used in Banner, Modal, and MobileBottomSheet components',
        }),
        dismiss: $t({
            defaultMessage: 'Dismiss',
            id: 'c5572a0852',
            description: 'Label for dismiss actions used in Banner component',
        }),
        remove: $t({
            defaultMessage: 'Remove',
            id: '08170a8a10',
            description: 'Label for delete/remove actions used in Chip component',
        }),
        clear: $t({
            defaultMessage: 'Clear',
            id: '51af1a9acf',
            description: 'Label for clear actions used in Input and Textarea components',
        }),
        cancel: $t({
            defaultMessage: 'Cancel',
            id: '13b5b94981',
            description: 'Label for cancel actions used in confirmation modals',
        }),
        confirm: $t({
            defaultMessage: 'Confirm',
            id: 'bd031f35ec',
            description: 'Label for generic confirmation actions used in confirmation modals',
        }),
        notifications: $t({
            defaultMessage: 'Notifications',
            id: '1c27dc4a36',
            description: 'Accessible name for the region that contains toast notifications',
        }),
        logoPerplexity: $t({
            defaultMessage: 'Perplexity',
            id: '64f46d5bcc',
            description: 'Accessible label for the Perplexity text logo',
        }),
        logoPerplexityPro: $t({
            defaultMessage: 'Perplexity Pro',
            id: '96d3acdf4f',
            description: 'Accessible label for the Perplexity Pro text logo',
        }),
        logoPerplexityMax: $t({
            defaultMessage: 'Perplexity Max',
            id: 'b0219d87c1',
            description: 'Accessible label for the Perplexity Max text logo',
        }),
        logoEnterprise: $t({
            defaultMessage: 'Enterprise',
            id: '0393de1bf2',
            description: 'Accessible label for the Enterprise text logo',
        }),
        logoEnterprisePro: $t({
            defaultMessage: 'Enterprise Pro',
            id: 'f29ec8af8e',
            description: 'Accessible label for the Enterprise Pro text logo',
        }),
        logoEnterpriseMax: $t({
            defaultMessage: 'Enterprise Max',
            id: '00bc51a34c',
            description: 'Accessible label for the Enterprise Max text logo',
        }),
        logoEducationPro: $t({
            defaultMessage: 'Education Pro',
            id: '83eadd625c',
            description: 'Accessible label for the Education Pro text logo',
        }),
        logoFull: $t({
            defaultMessage: 'Perplexity',
            id: 'daa82f9a80',
            description: 'Accessible label for the Perplexity full logo (icon and text)',
        }),
        logoMark: $t({
            defaultMessage: 'Perplexity',
            id: '141d8e8064',
            description: 'Accessible label for the Perplexity mark logo (icon only)',
        }),
        logoComputer: $t({
            defaultMessage: 'Computer',
            id: 'aaed1519bd',
            description: 'Accessible label for the Computer mark logo',
        }),
        logoPerplexityComputer: $t({
            defaultMessage: 'Perplexity Computer',
            id: '1e23ed632b',
            description: 'Accessible label for the Perplexity Computer text logo',
        }),
    }), [$t]);
}
//# sourceMappingURL=useLocalizedAetherLabels.js.map